import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../partials/inputForm";
import SearchInput from "../../../partials/SearchInput";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import CountryCode from "../../countryCode";
import DialogNotice from "../../dialog";
import Loading from "../../loading";
import PopupInterface from "../../popUpInterface";
import Snackbar from "../../snackbar";
import ListCustomer from "../../voucher/listCustomer";
import { styles } from "./styles";

class SendMembercard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      countryCode: this.props.defaultCountryCode || "+84",
      dialogOpen: this.props.dialogOpen,
      memberCardSend: this.props.memberCardSend,
      phoneList: [],
      valuePhoneNumber: "",
      dialog: {
        type: "",
        content: "",
      },
      sendPhoneList: {
        SMS: false,
        Notify: false,
      },
      sendCustomerList: {
        SMS: false,
        Notify: false,
      },
      checkResult: [],
      PopupResult: false,
      textSearch: "",
      selectedList: false,
    };
    this.handleDeletePhone = this.handleDeletePhone.bind(this);
    this.handleCountryCode = this.handleCountryCode.bind(this);
    this.onChangePhoneNumber = this.onChangePhoneNumber.bind(this);
    this.handleSendByPhone = this.handleSendByPhone.bind(this);
    this.handleSendByCustomerList = this.handleSendByCustomerList.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      this.setState({ countryCode: nextProps.defaultCountryCode });
    }
  }
  isInPhoneList(countryCode, valuePhoneNumber, phoneList) {
    for (let i = 0; i < phoneList.length; i++) {
      if (
        phoneList[i].countryCode === countryCode &&
        phoneList[i].valuePhoneNumber === valuePhoneNumber
      )
        return true;
    }
    return false;
  }
  onKeyPressPhone = async (event) => {
    event.preventDefault();
    let { t } = this.props;
    let { countryCode, valuePhoneNumber, phoneList } = this.state;
    let _this = this;
    let validPhone = _parsePhoneNumber(countryCode, valuePhoneNumber).isValid;
    if (validPhone) {
      let check = await this.props.checkSentUserMembercard({
        countryCode: countryCode,
        mobile: valuePhoneNumber,
        membercardCode: this.state.memberCardSend.code,
      });
      if (check && check.code === 1 && check.data === true)
        this.mSnackbar.handleClick(
          t("user_membercard_user_already_have_the_membercard") +
            ` ${this.state.memberCardSend.title}`,
          "warning"
        );
      else {
        let checkExist = this.isInPhoneList(
          countryCode,
          valuePhoneNumber,
          phoneList
        );
        if (checkExist) {
          this.mSnackbar.handleClick(
            t("voucher_uservoucher_phone_number_existed_in_list_selected"),
            "warning"
          );
        } else {
          this.loading.startLoading();
          let check = await this.props.customerDispatch.findCustomer({
            countryCode: countryCode,
            customerMobile: valuePhoneNumber,
          });
          this.loading.stopLoading();
          if (check.code === 1 || check.error === 1014) {
            // có hoặc không phải là customer
            phoneList.push({
              countryCode: countryCode,
              valuePhoneNumber: valuePhoneNumber,
              isCustomer: check.code === 1 ? true : false,
              customerName: (check.data && check.data.customerName) || "",
            });
            this.setState({ phoneList }, function () {
              _this.setState({ valuePhoneNumber: "" });
            });
          } else this.mSnackbar.handleClick(check.message, "warning");
        }
      }
    } else {
      this.mSnackbar.handleClick(
        t("voucher_uservoucher_phone_number_not_valid"),
        "warning"
      );
    }
  };
  onChangePhoneNumber = (e) => {
    this.setState({ valuePhoneNumber: e.target.value });
  };
  handleCountryCode = (name, value) => {
    this.setState({
      countryCode: value,
    });
  };
  handleDeletePhone(phone) {
    let phoneList = this.state.phoneList;
    for (let i = 0; i < phoneList.length; i++) {
      if (
        phoneList[i].countryCode === phone.countryCode &&
        phoneList[i].valuePhoneNumber === phone.valuePhoneNumber
      ) {
        phoneList.splice(i, 1);
        this.setState({ phoneList });
        return;
      }
    }
    return false;
  }
  handleTab = (event, value) => {
    this.setState({ tab: value });
  };
  handleClickOpen = (scroll) => () => {
    this.setState({ open: true, scroll });
  };
  handleClose = (event) => {
    this.setState({ dialogOpen: false });
  };
  handleOpenDialogNotice = (type) => {
    let _this = this;
    const { t } = this.props;
    let { sendCustomerList, sendPhoneList, phoneList } = this.state;
    if (type == "phone" && (sendPhoneList.SMS || sendPhoneList.Notify)) {
      // TH có chọn sendMethod
      let list = phoneList.map(
        (phone) =>
          _parsePhoneNumber(phone.countryCode, phone.valuePhoneNumber)
            .format_internal
      );
      let content = `${t("user_membercard_do_you_want_to_send_membercard")} ${
        this.state.memberCardSend.title
      } ${t("user_membercard_to_user")}: ${list.join(", ")}. ${t(
        "user_membercard_and_create_new_customer_if_they_are_not_in_customer_list"
      )}`;
      this.setState(
        {
          dialog: {
            type: type,
            content: content,
          },
        },
        function () {
          _this.mDialog.handleDialogOpen();
        }
      );
    } else if (
      type == "customerList" &&
      (sendCustomerList.SMS || sendCustomerList.Notify)
    ) {
      // TH có chọn sendMethod
      let idList = this.listCustomer.getIdCustomer();
      let list = idList.map(
        (phone) =>
          _parsePhoneNumber(phone.countryCode, phone.valuePhoneNumber)
            .format_internal
      );
      let content = `${t("user_membercard_do_you_want_to_send_membercard")} ${
        this.state.memberCardSend.title
      } ${t("user_membercard_to_user")}: ${list.join(", ")}`;
      this.setState(
        {
          dialog: {
            type: type,
            content: content,
          },
        },
        function () {
          _this.mDialog.handleDialogOpen();
        }
      );
    } else {
      this.setState(
        {
          dialog: {
            type: type,
          },
        },
        function () {
          _this.handleSendVoucher();
        }
      );
    }
  };
  handleSendVoucher = () => {
    let { t } = this.props;
    if (this.state.dialog.type === "phone") {
      if (!this.state.phoneList.length) {
        this.mDialog.handleDialogClose();
        this.mSnackbar.handleClick(
          t("voucher_uservoucher_please_enter_at_least_one_phone_number"),
          "warning"
        );
      } else {
        this.handleSendByPhone();
      }
    } else if (this.state.dialog.type === "customerList") {
      let idList = this.listCustomer.getIdCustomer();
      if (!idList.length) {
        this.mDialog.handleDialogClose();
        this.mSnackbar.handleClick(
          t("voucher_uservoucher_please_select_at_least_one_customer"),
          "warning"
        );
      } else {
        this.mDialog.handleDialogClose();
        this.handleSendByCustomerList();
      }
    }
  };
  handleSendByPhone = async () => {
    let _this = this;
    let { t } = this.props;
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let check = await this.props.userMembercardDispatch.sendMembercardForPhoneList(
      {
        phoneList: this.state.phoneList,
        memberCardSend: this.state.memberCardSend,
        methodSend: this.state.sendPhoneList,
      }
    );
    this.loading.stopLoading();
    if (check.code === 1) {
      this.listCustomer.resetSelected();
      let dataSendPhoneList = this.props.userMembercardState.dataSendPhoneList;
      // this.mSnackbar.handleClick(t('user_membercard_send_membercard')+' "'+this.state.memberCardSend.title+'" '+t('voucher_uservoucher_successfully'));
    } else {
      // this.mSnackbar.handleClick( t('user_membercard_send_membercard')+' "'+this.state.memberCardSend.title+'" '+t('voucher_uservoucher_unsuccessfully') + ' ' + check.message,'error');
    }
    this.props.afterSend(check);
    this.setState({
      phoneList: [],
    });
  };
  handleSendByCustomerList = async () => {
    let { t } = this.props;
    let idList = this.listCustomer.getIdCustomer();
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let check = await this.props.userMembercardDispatch.sendMembercardForCustomerList(
      {
        idList: idList,
        memberCardSend: this.state.memberCardSend,
        methodSend: this.state.sendCustomerList,
      }
    );
    this.loading.stopLoading();
    this.props.afterSend(check);
  };
  onChangeMethodSend = (nameMethod, action) => (event) => {
    let state = this.state;
    state[nameMethod][action] = event.target.checked === true ? 1 : 0;
    this.setState({ state });
  };
  handleChange = (event) => {
    this.setState({ textSearch: (event && event.target.value) || "" });
  };
  deleteSearchAndGetList = () => {
    this.setState({ textSearch: "" });
    this.listCustomer.handleSearch();
  };
  addCustomer = () => {
    this.listCustomer.openDialogAddCustomer();
  };
  handleSearch() {
    const { textSearch } = this.state;
    this.listCustomer.handleSearch(textSearch);
  }
  selectedList = (status) => {
    this.setState({
      selectedList: status,
    });
  };
  checkSentUser = async (data = {}) => {
    let { t } = this.props;
    let check = await this.props.checkSentUserMembercard({
      countryCode: data.countryCode,
      mobile: data.mobile,
      membercardCode: this.state.memberCardSend.code,
    });
    if (check && check.code === 1 && check.data === true)
      this.mSnackbar.handleClick(
        t("user_membercard_user_already_have_the_membercard") +
          ` ${this.state.memberCardSend.title}`,
        "warning"
      );
    else this.listCustomer.handleClick(data.id);
  };
  render() {
    const { classes, t } = this.props;
    const { tab, selectedList } = this.state;
    return (
      <PopupInterface
        handleDialogClose={this.props.handleDialogEditClose}
        flagOpen={this.state.dialogOpen}
        onRef={(dialog) => (this.PopUpInterface = dialog)}
      >
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <DialogNotice
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("voucher_uservoucher_cancel")}
          agree={t("voucher_uservoucher_send")}
          title={t("voucher_uservoucher_notice")}
          content={this.state.dialog.content}
          action={this.handleSendVoucher}
        />
        <Fragment>
          <DialogTitle
            id="scroll-dialog-title"
            disableTypography
            style={{ padding: 0 }}
          >
            <Typography variant="h4" className={classes.title}>
              {t("user_membercard_send_user_membercard_to_customer")}
            </Typography>
          </DialogTitle>
          <Grid container className={classes.gridContainer}>
            <AppBar position="static" color="default">
              <Tabs
                value={tab}
                onChange={this.handleTab}
                indicatorColor="primary"
                textColor="secondary"
                classes={{
                  root: classes.tabsRoot,
                  indicator: classes.tabsIndicator,
                }}
                scrollButtons="on"
                variant="scrollable"
              >
                <Tab
                  label={t("voucher_uservoucher_select_by_customer_list")}
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected,
                  }}
                />
                <Tab
                  label={t("voucher_uservoucher_select_by_phone_number")}
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected,
                  }}
                />
              </Tabs>
            </AppBar>
          </Grid>
          {tab == 0 && (
            <DialogContent className={classes.content}>
              <Grid container spacing={3} className={" tab-profile"}>
                <Grid item xs={12} sm={12} className={classes.titleFrame}>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.sendCustomerList.SMS}
                          onChange={this.onChangeMethodSend(
                            "sendCustomerList",
                            "SMS"
                          )}
                          value="list"
                        />
                      }
                      className={classes.label}
                      label={t("voucher_uservoucher_send_by_sms")}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.sendCustomerList.Notify}
                          onChange={this.onChangeMethodSend(
                            "sendCustomerList",
                            "Notify"
                          )}
                          value="list"
                        />
                      }
                      className={classes.label}
                      label={t("voucher_uservoucher_send_notify_on_app")}
                    />
                  </div>
                  <SearchInput
                    getList={this.handleSearch}
                    onChange={this.handleChange}
                    value={this.state.textSearch}
                    placeholder={t("voucher_uservoucher_search_by_name_phone")}
                    showFilter={false}
                    deleteSearchAndGetList={this.deleteSearchAndGetList}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <ListCustomer
                    onRef={(id) => {
                      this.listCustomer = id;
                    }}
                    listCustomer={this.props.customerState.listCustomer}
                    listBrands={this.props.serviceBranchState.listBrands}
                    selectedList={this.selectedList}
                    checkSentUser={this.checkSentUser}
                  />
                </Grid>
              </Grid>
            </DialogContent>
          )}
          {tab == 1 && (
            <DialogContent className={classes.content}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sendPhoneList.SMS}
                        onChange={this.onChangeMethodSend(
                          "sendPhoneList",
                          "SMS"
                        )}
                        value="list"
                      />
                    }
                    className={classes.label}
                    label={t("voucher_uservoucher_send_by_sms")}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sendPhoneList.Notify}
                        onChange={this.onChangeMethodSend(
                          "sendPhoneList",
                          "Notify"
                        )}
                        value="list"
                      />
                    }
                    className={classes.label}
                    label={t("voucher_uservoucher_send_notify_on_app")}
                  />
                </Grid>
                <form
                  onSubmit={this.onKeyPressPhone}
                  className={classes.containerPhoneInput}
                >
                  <Grid item xs={12} sm={4} className={classes.phoneInput}>
                    <CountryCode
                      code={this.state.countryCode}
                      handleCountryCode={this.handleCountryCode}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.phoneInput}>
                    <InputFormat
                      label={t("voucher_uservoucher_type_phone_number")}
                      name="valuePhoneNumber"
                      value={this.state.valuePhoneNumber || ""}
                      onChange={this.onChangePhoneNumber}
                      fullWidth={true}
                    />
                  </Grid>
                </form>
                <Grid item xs={12} sm={12} className={classes.containerButton}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.onKeyPressPhone}
                    className={classes.buttonAddPhone}
                  >
                    {t("voucher_uservoucher_button_add")}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="h6" gutterBottom>
                    {t("voucher_uservoucher_list_selected")}
                  </Typography>
                </Grid>
                {this.state.phoneList.length > 0 && (
                  <Grid item xs={12} sm={12} className={classes.list}>
                    {this.state.phoneList.map((phone, index) => {
                      let prefix = phone.isCustomer
                        ? phone.customerName + " | "
                        : "";
                      return (
                        <Chip
                          key={index}
                          label={
                            prefix +
                            phone.countryCode +
                            " " +
                            phone.valuePhoneNumber
                          }
                          onDelete={this.handleDeletePhone.bind(this, phone)}
                          className={classes.chip}
                        />
                      );
                    })}
                  </Grid>
                )}
              </Grid>
            </DialogContent>
          )}
          {tab === 0 && (
            <div className={classes.footerList}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                className={classes.button}
                onClick={() => this.addCustomer()}
              >
                {t("membercard_user_member_card_add_customer_button")}
              </Button>
              <Button
                disabled={selectedList ? false : true}
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => this.handleOpenDialogNotice("customerList")}
              >
                {t("voucher_uservoucher_send")}
              </Button>
            </div>
          )}

          {tab === 1 && (
            <div item xs={12} sm={12} className={classes.footerList}>
              <Button
                disabled={this.state.phoneList.length ? false : true}
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => this.handleOpenDialogNotice("phone")}
              >
                {t("voucher_uservoucher_send")}
              </Button>
            </div>
          )}
        </Fragment>
      </PopupInterface>
    );
  }
}

SendMembercard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  serviceBranchState: state.serviceBranch,
  customerState: state.customer,
  userMembercardState: state.userMembercard,
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
});

const mapDispatch = (dispatch) => ({
  customerDispatch: dispatch.customer,
  userMembercardDispatch: dispatch.userMembercard,
  checkSentUserMembercard: dispatch.userMembercard.checkSentUserMembercard,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SendMembercard)
  )
);
